export default __webpack_public_path__ + "img/cf6dfc9b6d65bc3f707321909e27b6a6.png";